import combineSx from '@liquidweb-dev/undercurrent/utility/combineSx';
import CloseIcon from '@liquidweb-dev/undercurrent/icons/lucide/X';
import Dialog, { type DialogProps } from '@liquidweb-dev/undercurrent/Dialog';
import { paperClasses } from '@liquidweb-dev/undercurrent/Paper';
import DialogContent from '@liquidweb-dev/undercurrent/DialogContent';
import DialogTitle from '@liquidweb-dev/undercurrent/DialogTitle';
import IconButton from '@liquidweb-dev/undercurrent/IconButton';

export interface DialogDestroyAddonProps extends Omit<DialogProps, 'onClose'> {
	title?: string;
	subtitle?: string;
	onClose: () => void;
}

const DialogDestroyAddon = ({
	title,
	children,
	onClose,
	sx,
	...dialogProps
}: DialogDestroyAddonProps) => {
	return (
		<Dialog
			onClose={onClose}
			{...dialogProps}
			sx={{
				[`.${paperClasses.root}`]: { xs: '100%', sm: { minWidth: '504px' } },
				...sx,
			}}
		>
			<DialogTitle sx={{ fontWeight: 500 }}>
				{title || 'Cancel service'}
			</DialogTitle>
			<IconButton
				variant="barebones"
				size="large"
				onClick={onClose}
				aria-label="Close dialog"
				sx={{ position: 'absolute', right: '24px', top: '24px' }}
			>
				<CloseIcon />
			</IconButton>
			<DialogContent
				sx={combineSx(
					{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						paddingX: 300,
						paddingBottom: { xs: 700, sm: 300 },
					},
					sx,
				)}
			>
				{children}
			</DialogContent>
		</Dialog>
	);
};

export default DialogDestroyAddon;
